module.exports = __webpack_public_path__ + "static/sport/center-item.c40d2f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center-item.png
// module id = I6ve
// module chunks = 0